export const locale = {
	lang: 'it',
	data: {
		
	}
};
